/* Blusafe Australia — G2 Wi-Fi Gateway interactive manual data.
   Rendered by au-manual-engine.js (see sections/au-g2-gateway-manual.liquid).
   Guide content: September 2026 source manual. Illustrations: au-manual-g2-*.webp. */
window.G2_GATEWAY_MANUAL_DATA = {
  "manual": {
    "title": "G2 Wi-Fi Gateway Setup and Troubleshooting Manual",
    "product_family": "G2 Wi-Fi Gateway",
    "manual_version": "V2026.1",
    "source_edition": "September 2026 source manual",
    "primary_app": "TTLock",
    "install_time_estimate": "10–15 minutes",
    "lead": "Power up your G2 gateway, read its LED, bind it to your TTLock lock over 2.4 GHz Wi-Fi so you can unlock remotely, and fix the most common binding and network problems — without opening the PDF.",
    "app_links": {
      "android_google_play": "https://play.google.com/store/apps/details?id=com.tongtongsuo.app",
      "ios_app_store": "https://apps.apple.com/app/ttlock/id1033046018"
    },
    "compatible_apps": {
      "TTLock (recommended)": {
        "android": "https://play.google.com/store/apps/details?id=com.tongtongsuo.app",
        "ios": "https://apps.apple.com/app/ttlock/id1033046018"
      }
    },
    "critical_warnings": [
      "Add your Blusafe TTLock lock to the app before you add the gateway.",
      "Your router must broadcast a 2.4 GHz network — the G2 cannot join 5 GHz.",
      "Have the Wi-Fi password ready and check its capitalisation.",
      "Place the gateway within Bluetooth range of the lock and Wi-Fi range of the router.",
      "Wait for the red and blue alternating flash before you tap Next."
    ]
  },
  "guides": [
    {
      "handle": "g2-01",
      "title": "Understand the LED indicator",
      "category": "Preparation",
      "estimated_time": "2 minutes",
      "difficulty": "Easy",
      "summary": "Understand the meaning of different LED indicator light patterns on the G2 Smart Gateway.",
      "images": [
        {
          "src": "au-manual-g2-01-1.webp",
          "alt": "Light status description — Light Status Description"
        }
      ],
      "notes": [
        "Red and Blue Alternating Flash: Ready state - the gateway is available to be added and bound by the app.",
        "Solid Red: Poor network connection - the gateway cannot communicate with the server.",
        "Solid Blue: Normal working status - cannot be bound."
      ],
      "warnings": [],
      "tips": [],
      "steps": [
        "Observe the LED indicator light on the gateway after powering it on.",
        "Identify the colour and flashing pattern of the indicator light.",
        "Refer to the status descriptions below to determine the current device state."
      ],
      "expected_result": "You can correctly identify whether the gateway is in ready state, has poor network connection, or is in normal working status based on the LED indicator behaviour.",
      "common_mistakes": [
        "Confusing red/blue alternating flash with solid blue - Alternating flash means ready for binding; solid blue means already bound and working normally.",
        "Ignoring red indicator light - Red light indicates poor network connectivity and inability to communicate with the server, requiring immediate attention.",
        "Attempting to bind when indicator is solid blue - A solid blue light means the gateway cannot be bound as it is already connected to another account."
      ]
    },
    {
      "handle": "g2-02",
      "title": "Bind the gateway to the TTLock app",
      "category": "App setup",
      "estimated_time": "5–10 minutes",
      "difficulty": "Easy",
      "summary": "Connect the G2 Smart Gateway to the TTLock app and configure it for use with your Wi-Fi network.",
      "images": [
        {
          "src": "au-manual-g2-02-1.webp",
          "alt": "Bind the gateway to the app — Bind the Gateway to the app"
        }
      ],
      "notes": [],
      "warnings": [
        "Only 2.4 GHz Wi-Fi networks are supported. Ensure your router broadcasts a 2.4 GHz signal before proceeding. 5 GHz networks will not work with this device."
      ],
      "tips": [],
      "steps": [
        "Connect the gateway to a power supply using the provided adapter.",
        "Open the \"TTLock\" app on your smartphone.",
        "Tap the \"+\" button in the upper right corner of the app home screen.",
        "Select \"G2 (Wi-Fi)\" from the device list.",
        "Verify the gateway indicator is flashing red and blue alternately, then tap \"Next\".",
        "When the G2 device appears in the search results, tap the \"+\" button next to it.",
        "Tap \"Wi-Fi Name\" to select your available 2.4 GHz Wi-Fi network from the list.",
        "Enter your Wi-Fi password accurately.",
        "Enter a recognisable name for your Gateway (e.g., \"Living Room Gateway\").",
        "Tap \"OK\" to complete the binding process.",
        "Wait for the gateway to automatically search for and connect to devices already bound in the app."
      ],
      "expected_result": "The gateway indicator turns solid blue, indicating normal working status, and the device appears in your TTLock app device list ready for use.",
      "common_mistakes": [
        "Using 5 GHz Wi-Fi instead of 2.4 GHz - The G2 gateway only supports 2.4 GHz networks; 5 GHz will cause connection failure.",
        "Entering incorrect Wi-Fi password - Double-check the password before submitting to avoid binding failure.",
        "Skipping the gateway naming step - A clear name helps identify the device when managing multiple gateways in the app.",
        "Attempting to bind when the indicator is solid blue - Solid blue means the device is already bound; if re-binding is needed, you must first delete the device from the app."
      ],
      "app_links": true
    },
    {
      "handle": "g2-03",
      "title": "Delete the gateway",
      "category": "Management",
      "estimated_time": "2 minutes",
      "difficulty": "Easy",
      "summary": "Remove the G2 Smart Gateway from your TTLock app account and disconnect it from your network.",
      "images": [
        {
          "src": "au-manual-g2-03-1.webp",
          "alt": "Delete the gateway — Delete the Gateway"
        }
      ],
      "notes": [],
      "warnings": [],
      "tips": [],
      "steps": [
        "Open the \"TTLock\" app on your smartphone.",
        "Navigate to the device list and select the gateway you want to delete.",
        "Tap the settings or options menu for the selected gateway.",
        "Tap \"Delete\" to initiate the removal process.",
        "Confirm the deletion when prompted by the app."
      ],
      "expected_result": "The gateway is removed from your app device list and can no longer be controlled through your account. The gateway indicator will return to alternating red and blue flash, indicating it is ready to be bound by a new account.",
      "common_mistakes": [
        "Deleting the wrong gateway - Verify the gateway name and location before confirming deletion to avoid removing the wrong device.",
        "Not confirming deletion in the app - Tapping \"Delete\" alone may not complete the process; you must confirm in the subsequent prompt.",
        "Expecting immediate physical reset - Deleting from the app removes the logical connection; the gateway hardware remains powered and will show ready state for re-binding."
      ]
    }
  ],
  "troubleshooting": [
    {
      "handle": "g2-wont-bind",
      "title": "Gateway won't add or bind in the app",
      "category": "App setup",
      "priority": "high",
      "explanation": "Binding only works while the gateway is in its ready state (red and blue alternating flash) and your phone can reach a 2.4 GHz network. If the LED is solid blue the gateway is already bound to an account; if the network is 5 GHz-only the join fails every time.",
      "symptoms": [
        "The G2 never appears in the search list after you tap Next.",
        "Binding starts but fails at the Wi-Fi step.",
        "The app times out while the gateway is still flashing."
      ],
      "quick_checks": [
        "The LED is flashing red and blue alternately — not solid blue or solid red.",
        "You chose \"G2 (Wi-Fi)\" from the device list, not a different gateway model.",
        "The Wi-Fi network you picked is 2.4 GHz, and the password is typed with the right capitalisation.",
        "Bluetooth is on and your phone is next to the gateway."
      ],
      "likely_causes": [
        "The gateway is already bound (solid blue) to this or another account.",
        "The router only offers 5 GHz, or the 2.4 GHz and 5 GHz networks share one name and the phone chose 5 GHz.",
        "A mistyped Wi-Fi password.",
        "The gateway is too far from the router."
      ],
      "fix_steps": [
        "Unplug the gateway, wait 10 seconds, plug it back in and wait for the red and blue alternating flash.",
        "If the LED is solid blue, delete the gateway from the TTLock app (or ask the previous owner to), then power cycle it.",
        "In the app tap +, choose \"G2 (Wi-Fi)\", tap Next as soon as the LED is alternating, then tap + next to the G2 when it appears.",
        "Pick a 2.4 GHz network by name — if your router merges bands, temporarily split them or move nearer the router.",
        "Re-type the Wi-Fi password, give the gateway a name and tap OK."
      ],
      "related_guides": [
        "g2-01",
        "g2-02",
        "g2-03"
      ],
      "support_evidence": [
        "A short video of the LED after power-up",
        "A screenshot of the Wi-Fi step in the app",
        "Router make/model and whether it has a separate 2.4 GHz network"
      ],
      "app_links": false
    },
    {
      "handle": "g2-solid-red",
      "title": "LED is solid red — gateway shows offline",
      "category": "Network",
      "priority": "high",
      "explanation": "Solid red means the gateway cannot reach the TTLock server. The gateway is bound, but its Wi-Fi or internet path is broken — usually a router change, a weak signal or an internet outage.",
      "symptoms": [
        "The gateway LED is solid red.",
        "The gateway shows as offline in the app.",
        "Remote unlock fails with a network error."
      ],
      "quick_checks": [
        "Other devices on the same Wi-Fi can reach the internet.",
        "The router name or password has not been changed since binding.",
        "The gateway is within good range of the router — not behind thick walls or metal.",
        "The 2.4 GHz network is still switched on at the router."
      ],
      "likely_causes": [
        "Internet outage or router restart.",
        "Wi-Fi password or network name changed.",
        "Weak 2.4 GHz signal at the gateway position."
      ],
      "fix_steps": [
        "Restart the router and wait two minutes.",
        "Unplug the gateway, wait 10 seconds and plug it back in — solid blue means it is back online.",
        "If the Wi-Fi details changed, delete the gateway from the app and bind it again with the new details.",
        "Move the gateway closer to the router or away from interference and retest."
      ],
      "related_guides": [
        "g2-01",
        "g2-02"
      ],
      "support_evidence": [
        "A short video of the LED",
        "Whether the router or Wi-Fi password changed recently",
        "Distance and obstacles between gateway and router"
      ],
      "app_links": false
    },
    {
      "handle": "g2-solid-blue",
      "title": "LED is solid blue but the app will not add it",
      "category": "App setup",
      "priority": "medium",
      "explanation": "Solid blue is the normal working state — the gateway is already bound to an account. A bound gateway cannot be added a second time. It must be deleted from the account it belongs to before it can be bound again.",
      "symptoms": [
        "The LED never flashes red and blue after power-up.",
        "The app cannot find the gateway when you tap Next."
      ],
      "quick_checks": [
        "You did not already add this gateway under a different login.",
        "The gateway did not come from another installation or a previous owner."
      ],
      "likely_causes": [
        "The gateway is bound to your own account already.",
        "The gateway is bound to someone else's account."
      ],
      "fix_steps": [
        "Open the TTLock app and check your device list for the gateway — if it is there, it is already set up.",
        "To move it to a new account, select the gateway in the app, tap Delete and confirm.",
        "Power cycle the gateway; the LED returns to the alternating flash and it can be bound again.",
        "If it belonged to someone else and they cannot delete it, contact Blusafe Australia with proof of purchase."
      ],
      "related_guides": [
        "g2-01",
        "g2-03"
      ],
      "support_evidence": [
        "Proof of purchase",
        "A photo of the label on the underside of the gateway"
      ],
      "app_links": false
    },
    {
      "handle": "g2-remote-unlock",
      "title": "Gateway is online but remote unlock does not work",
      "category": "Everyday use",
      "priority": "medium",
      "explanation": "After binding, the gateway automatically searches for locks already in your app and connects to those within Bluetooth range. If the lock is too far from the gateway, or remote unlock is switched off in the lock settings, remote commands fail even though the gateway is online.",
      "symptoms": [
        "The gateway shows online but the lock still shows as not connected.",
        "Remote unlock times out or reports failure."
      ],
      "quick_checks": [
        "The lock is added to the same TTLock account as the gateway.",
        "The gateway is within Bluetooth range of the lock — ideally in the same room.",
        "Remote Unlock is enabled in the lock's Settings in the app.",
        "The lock's batteries are not low."
      ],
      "likely_causes": [
        "Gateway placed too far from the lock.",
        "Remote unlock disabled in the lock settings.",
        "The lock was added to the app after the gateway searched — it has not connected yet."
      ],
      "fix_steps": [
        "Move the gateway nearer the lock and wait a minute for it to connect.",
        "In the app open the lock, tap Settings and turn on Remote Unlock if it is off.",
        "Power cycle the gateway so it searches for locks again.",
        "If it still fails, delete and re-bind the gateway."
      ],
      "related_guides": [
        "g2-02"
      ],
      "support_evidence": [
        "A screenshot of the gateway page showing connected locks",
        "Distance between the gateway and the lock"
      ],
      "app_links": false
    }
  ],
  "videos": [],
  "support_templates": [
    {
      "title": "Gateway won't bind",
      "subject": "G2 Wi-Fi Gateway - will not bind to the TTLock app",
      "body": "Hi Blusafe team,\n\nMy G2 Wi-Fi Gateway will not bind to the TTLock app. Here are my details:\n\nOrder number: \nLock the gateway is meant to connect to: \nLED pattern after power-up (red/blue alternating, solid red, solid blue): \nRouter make/model and whether it has a separate 2.4 GHz network: \nHow far the gateway is from the router: \n\nI have attached:\n- A short video of the gateway LED\n- A screenshot of the step where the app fails\n\nThanks,\n[Your name]"
    },
    {
      "title": "Gateway keeps going offline",
      "subject": "G2 Wi-Fi Gateway - shows offline / solid red",
      "body": "Hi Blusafe team,\n\nMy G2 Wi-Fi Gateway keeps showing offline. Here are my details:\n\nOrder number: \nLED pattern (solid red / other): \nHow often it drops offline: \nWhether the router or Wi-Fi password changed recently: \nDistance and obstacles between the gateway and the router: \n\nThanks,\n[Your name]"
    }
  ],
  "support_evidence_default": [
    "Order number and which app you used (TTLock)",
    "Which lock the gateway is meant to connect to",
    "Your router's Wi-Fi band (2.4 GHz or 5 GHz) and whether the phone is on the same network",
    "A short video of the gateway LED after it powers up",
    "A screenshot of the gateway page in the app"
  ],
  "search_index": [
    {
      "title": "G2 Wi-Fi Gateway Setup and Troubleshooting Manual",
      "type": "manual",
      "category": "Overview",
      "anchor": "osp-top",
      "summary": "Power up your G2 gateway, read its LED, bind it to your TTLock lock over 2.4 GHz Wi-Fi so you can unlock remotely, and fix the most common binding and network problems — without opening the PDF.",
      "keywords": "g2 gateway wi-fi bridge hub ttlock remote unlock bind pair led solid red solid blue alternating 2.4 ghz delete"
    },
    {
      "title": "Understand the LED indicator",
      "type": "guide",
      "category": "Preparation",
      "anchor": "g2-01",
      "summary": "Understand the meaning of different LED indicator light patterns on the G2 Smart Gateway.",
      "keywords": "Observe the LED indicator light on the gateway after powering it on. Identify the colour and flashing pattern of the indicator light. Refer to the status descriptions below to determine the current device state. Red and Blue Alternating Flash: Ready state - the gateway is available to be added and bound by the app. Solid Red: Poor network connection - the gateway cannot communicate with the server. Solid Blue: Normal working status - cannot be bound. Confusing red/blue alternating flash with solid blue - Alternating flash means ready for binding; solid blue means already bound and working normally. Ignoring red indicator light - Red light indicates poor network connectivity and inability to communicate with the server, requiring immediate attention. Attempting to bind when indicator is solid blue - A solid blue light means the gateway cannot be bound as it is already connected to another account."
    },
    {
      "title": "Bind the gateway to the TTLock app",
      "type": "guide",
      "category": "App setup",
      "anchor": "g2-02",
      "summary": "Connect the G2 Smart Gateway to the TTLock app and configure it for use with your Wi-Fi network.",
      "keywords": "Connect the gateway to a power supply using the provided adapter. Open the \"TTLock\" app on your smartphone. Tap the \"+\" button in the upper right corner of the app home screen. Select \"G2 (Wi-Fi)\" from the device list. Verify the gateway indicator is flashing red and blue alternately, then tap \"Next\". When the G2 device appears in the search results, tap the \"+\" button next to it. Tap \"Wi-Fi Name\" to select your available 2.4 GHz Wi-Fi network from the list. Enter your Wi-Fi password accurately. Enter a recognisable name for your Gateway (e.g., \"Living Room Gateway\"). Tap \"OK\" to complete the binding process. Wait for the gateway to automatically search for and connect to devices already bound in the app. Only 2.4 GHz Wi-Fi networks are supported. Ensure your router broadcasts a 2.4 GHz signal before proceeding. 5 GHz networks will not work with this device. Using 5 GHz Wi-Fi instead of 2.4 GHz - The G2 gateway only supports 2.4 GHz networks; 5 GHz will cause connection failure. Entering incorrect Wi-Fi password - Double-check the password before submitting to avoid binding failure. Skipping the gateway naming step - A clear name helps identify the device when managing multiple gateways in the app. Attempting to bind when the indicator is solid blue - Solid blue means the device is already bound; if re-binding is needed, you must first delete the device from the app."
    },
    {
      "title": "Delete the gateway",
      "type": "guide",
      "category": "Management",
      "anchor": "g2-03",
      "summary": "Remove the G2 Smart Gateway from your TTLock app account and disconnect it from your network.",
      "keywords": "Open the \"TTLock\" app on your smartphone. Navigate to the device list and select the gateway you want to delete. Tap the settings or options menu for the selected gateway. Tap \"Delete\" to initiate the removal process. Confirm the deletion when prompted by the app. Deleting the wrong gateway - Verify the gateway name and location before confirming deletion to avoid removing the wrong device. Not confirming deletion in the app - Tapping \"Delete\" alone may not complete the process; you must confirm in the subsequent prompt. Expecting immediate physical reset - Deleting from the app removes the logical connection; the gateway hardware remains powered and will show ready state for re-binding."
    },
    {
      "title": "Gateway won't add or bind in the app",
      "type": "troubleshooting",
      "category": "App setup",
      "anchor": "g2-wont-bind",
      "summary": "The G2 never appears in the search list after you tap Next.",
      "keywords": "The G2 never appears in the search list after you tap Next. Binding starts but fails at the Wi-Fi step. The app times out while the gateway is still flashing. The gateway is already bound (solid blue) to this or another account. The router only offers 5 GHz, or the 2.4 GHz and 5 GHz networks share one name and the phone chose 5 GHz. A mistyped Wi-Fi password. The gateway is too far from the router. Unplug the gateway, wait 10 seconds, plug it back in and wait for the red and blue alternating flash. If the LED is solid blue, delete the gateway from the TTLock app (or ask the previous owner to), then power cycle it. In the app tap +, choose \"G2 (Wi-Fi)\", tap Next as soon as the LED is alternating, then tap + next to the G2 when it appears. Pick a 2.4 GHz network by name — if your router merges bands, temporarily split them or move nearer the router. Re-type the Wi-Fi password, give the gateway a name and tap OK. Binding only works while the gateway is in its ready state (red and blue alternating flash) and your phone can reach a 2.4 GHz network. If the LED is solid blue the gateway is already bound to an account; if the network is 5 GHz-only the join fails every time."
    },
    {
      "title": "LED is solid red — gateway shows offline",
      "type": "troubleshooting",
      "category": "Network",
      "anchor": "g2-solid-red",
      "summary": "The gateway LED is solid red.",
      "keywords": "The gateway LED is solid red. The gateway shows as offline in the app. Remote unlock fails with a network error. Internet outage or router restart. Wi-Fi password or network name changed. Weak 2.4 GHz signal at the gateway position. Restart the router and wait two minutes. Unplug the gateway, wait 10 seconds and plug it back in — solid blue means it is back online. If the Wi-Fi details changed, delete the gateway from the app and bind it again with the new details. Move the gateway closer to the router or away from interference and retest. Solid red means the gateway cannot reach the TTLock server. The gateway is bound, but its Wi-Fi or internet path is broken — usually a router change, a weak signal or an internet outage."
    },
    {
      "title": "LED is solid blue but the app will not add it",
      "type": "troubleshooting",
      "category": "App setup",
      "anchor": "g2-solid-blue",
      "summary": "The LED never flashes red and blue after power-up.",
      "keywords": "The LED never flashes red and blue after power-up. The app cannot find the gateway when you tap Next. The gateway is bound to your own account already. The gateway is bound to someone else's account. Open the TTLock app and check your device list for the gateway — if it is there, it is already set up. To move it to a new account, select the gateway in the app, tap Delete and confirm. Power cycle the gateway; the LED returns to the alternating flash and it can be bound again. If it belonged to someone else and they cannot delete it, contact Blusafe Australia with proof of purchase. Solid blue is the normal working state — the gateway is already bound to an account. A bound gateway cannot be added a second time. It must be deleted from the account it belongs to before it can be bound again."
    },
    {
      "title": "Gateway is online but remote unlock does not work",
      "type": "troubleshooting",
      "category": "Everyday use",
      "anchor": "g2-remote-unlock",
      "summary": "The gateway shows online but the lock still shows as not connected.",
      "keywords": "The gateway shows online but the lock still shows as not connected. Remote unlock times out or reports failure. Gateway placed too far from the lock. Remote unlock disabled in the lock settings. The lock was added to the app after the gateway searched — it has not connected yet. Move the gateway nearer the lock and wait a minute for it to connect. In the app open the lock, tap Settings and turn on Remote Unlock if it is off. Power cycle the gateway so it searches for locks again. If it still fails, delete and re-bind the gateway. After binding, the gateway automatically searches for locks already in your app and connects to those within Bluetooth range. If the lock is too far from the gateway, or remote unlock is switched off in the lock settings, remote commands fail even though the gateway is online."
    }
  ],
  "support_email": ""
};
